import { MarkdownContent } from '@reflex/ui/components/content/MarkdownContent';
import type { GenericMarkdownPayload } from '../../../shared/types.js';

export interface GenericMarkdownRendererProps {
  payload: GenericMarkdownPayload;
}

export function GenericMarkdownRenderer({ payload }: GenericMarkdownRendererProps) {
  return (
    <div data-testid="notification-renderer-generic-markdown">
      <MarkdownContent content={payload.markdown} size="prose" />
    </div>
  );
}
